import { Component, Input } from '@angular/core';

import { JumbotronVariantEnum } from '~/attendee/components/shared/jumbotron/enums/jumbotron-variant.enum';
import { TextColorEnum } from '~/cms/enums/text-color.enum';
import {
  ImageCms,
  JumbotronCms,
} from '~/cms/interfaces/homepage.cms.interface';
import { AutocompleteSuggestion } from '~/component/form/autocomplete/interfaces/suggestion.interface';
import { InputStyleEnum } from '~/component/form/input/enums/style.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { TitleService } from '~/core/services/title/title.service';

@Component({
  selector: 'app-attendee-jumbotron-activities',
  templateUrl: './activities.component.html',
})
export class AttendeeJumbotronActivitiesComponent {
  @Input() public description: string;
  @Input() public readonly jumbotron: JumbotronCms;
  @Input() public readonly title: string;
  @Input() public readonly variant: JumbotronVariantEnum;
  @Input() public readonly isHp: boolean;

  public inputIcon = VtmnPlayIconTypeEnum.MapPin;
  public inputStyle = InputStyleEnum.Shadowed;
  public suggestions: AutocompleteSuggestion[] = [];

  constructor(protected readonly titleService: TitleService) {
    this.setTitle();
  }

  public get imgDesktop(): ImageCms {
    return this.jumbotron?.imageDesktop;
  }

  public get imgMobile(): ImageCms {
    return this.jumbotron?.imageMobile;
  }

  public get textColor(): TextColorEnum {
    return this.jumbotron?.textColor;
  }

  public setTitle(): void {
    this.titleService.setPageTitle(this.title);
  }
}
